<template>
  <div>
    <a-dialog
      v-model="show"
      width="900px"
      max-width="90vw"
      persistent
      scrollable
    >
      <email-notification-templates 
        v-if="step === 1" 
        :section="section"
        :selectedTemplateId="selectedTemplateId"
        @nextStep="nextStep"
        @close="show = false"
        ></email-notification-templates>
      <send-template-notification
        v-else
          :emailTemplate="emailTemplate"
          :defaulter="remindAttendees"
          :suggestedList="suggestedAttendees"
          @send="onEmailSend"
          :heading="alertHeading"
          :isImageSupport="section === 'ConvocationMail'"
          :section="section"
          :meetingPurpose="meetingPurpose"
          @backStep="step=1"
          @close="show = false"
        ></send-template-notification>
      <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
    </a-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import SendTemplateNotification from "./SendTemplateNotification.vue";
import EmailNotificationTemplates from "./agenda/EmailNotificationTemplates.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import PlaceholderMixin from "../mixin/PlaceholderMixin";

export default {
  name: "EmailSelectionDialog",
  mixins: [ PlaceholderMixin],
  data() {
    return {
      step: 1,
      selectedTemplateId: null,
      displayMessage: false,
      message: "",
      messageType: "",
      alertTemplate: this.emailTemplate ?? {},
    };
  },
  components: {
    SendTemplateNotification,
    EmailNotificationTemplates,
    MessageSheet
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: null,
    },
    emailTemplate: {
      type: Object,
      required: true,
    },
    defaulter: {
      type: Array,
      required: true,
    },
    suggestedList: {
      type: Array,
      required: true,
    },
    isImageSupport: {
      type: Boolean,
      default: false,
    },
    section: {
      type: String,
    },
    meetingPurpose: {
      type: String,
      default: "",
    }
  },
  computed: {
    ...mapState({
      meetingObject: (state) => state.meeting.meetingDetails,
    }),
    ...mapGetters({
      getTemplateByTemplateTypeId: "tenant/getTemplateByTemplateTypeId",
      getTemplateByTemplateId: "tenant/getTemplateByTemplateId",
    }),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    alertHeading(){
      return this.heading ? this.heading : this.$t('agenda.lblSendEmail');
    },
    remindAttendees(){
      return this.defaulter;
    },
    suggestedAttendees(){
      return this.suggestedList;
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      if (tenant) {
        return tenant.name;
      }
      return "";
    },
    getSelectedTemplate(){
      if(this.section === 'ConvocationMail'){
        return this.getTemplateByTemplateId(
          "ConvocationMail",
          this.selectedTemplateId,
          this.selectedLang
        );
      } else if(this.section === 'RemindVotingConsent'){
        return this.getTemplateByTemplateId(
          "RemindVotingConsent",
          this.selectedTemplateId,
          this.selectedLang
        );
      }else{
        return ""
      }
    },
  },
  mounted() {
   
  },
 methods:{
  nextStep(templateId){
    this.selectedTemplateId = templateId;
    const placeHolderVariables = this.replaceMeetingDataPlaceholders(
          this.meetingObject,
          this.meetingPurpose
        );
        this.alertTemplate.subject = this.getSelectedTemplate.subject.replace(
            /{{%[^}]+%}}/g,
            (match) => placeHolderVariables[match] || ""
          );
          this.alertTemplate.message = this.getSelectedTemplate.body.replace(
            /{{%[^}]+%}}/g,
            (match) => placeHolderVariables[match] || ""
          );
    this.step = 2;
  },
  showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
  onEmailSend(isSucess) {
      this.$emit("send", isSucess);
      this.show = false
    },
 }
 
};
</script>
